module.exports = __webpack_public_path__ + "static/media/thum_1.991a07d8.jpg";